import { $window } from '@umu/umu-dom';
import { baseLogger } from './baseLogger';


enum LOG_MONITOR_TYPE {
    LXP_SEARCH_4 = 'LXP_SEARCH_4',
}

interface ILogData extends Record<string, any> {
    tag: LOG_MONITOR_TYPE,
    msg: string;
}
/**
 * 搜索4的log
 * @param msg
 */
const logSearch4 = (msg: string) => {
    const data = {
        tag: LOG_MONITOR_TYPE.LXP_SEARCH_4,
        msg,
    }
    baseLogger.log(data);
}

const setSearch4BizTagType = () => {
    ($window as any).log_biz_tag_type = LOG_MONITOR_TYPE.LXP_SEARCH_4;
}

const log = (data: ILogData) => {
    baseLogger.log(data);
}

export {
    ILogData,
    LOG_MONITOR_TYPE,
    log,
    logSearch4,
    setSearch4BizTagType,
}
